(function () {
  function launchMaps() {
    var $maps = document.querySelectorAll('.js-map');
    if ($maps.length) {
      $maps.forEach(function ($map) {

        var $mapView = $map.querySelector('.js-map-view');
        var $mapLocations = $map.querySelectorAll('.js-map-location');
        var markers = [];
        var i = 1;
        var map = L.map($mapView, {
          center: [48.18922, -2.91275],
          zoom: 10,
          minZoom: 8,
          maxZoom: 16,
          scrollWheelZoom: false,
          dragging: !L.Browser.mobile
        });

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);

        $mapLocations.forEach(function ($location) {
          var marker = L.marker([$location.getAttribute('data-lat'), $location.getAttribute('data-long')], {
            icon: L.icon({
              iconUrl: '/themes/pil-base/assets/images/layout/map-marker.svg',
              iconSize: [20, 28],
              iconAnchor: [10, 28],
            }),
            title: $location.getAttribute('data-title')
          }).addTo(map);
          markers.push(marker);
          i++;
        });

        var refit = function (map, markers) {
          var group = new L.featureGroup(markers);
          map.fitBounds(group.getBounds(), { padding: [10, 10], maxZoom: 10 });
        };

        refit(map, markers);
        window.addEventListener('resize', function () {
          refit(map, markers);
        });

      });
    }
  }
  $(window).on('load', launchMaps);
})(jQuery);
